module.exports = __webpack_public_path__ + "static/media/4.02223e4e.jpg";